import {
  CodeBook,
  ExportTypeEnum,
  PagedResult,
} from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils/apiUtils";

import { CodeBookPagedFilter, SaveResult } from "../../models";
import {
  CountyCommittee,
  CommitteeSearch,
  CommitteeRole,
} from "../../models/Committee";

const apiUrlPrefix: string = "county-committees";

export const getCountyCommitteeById = async (id: number) => {
  return api.get(
    `${apiUrlPrefix}/get-committee/${id}`
  ) as Promise<CountyCommittee>;
};

export const createCountyCommitteeById = async (countyId: number) => {
  return api.get(
    `${apiUrlPrefix}/create-countycommittee/${countyId}`
  ) as Promise<CountyCommittee>;
};

export const searchCountyCommittee = async (search: CommitteeSearch) => {
  return api.post(`${apiUrlPrefix}/search-committees`, search) as Promise<
    PagedResult<CountyCommittee>
  >;
};

export const getCountyCommitteeStatusList = async () => {
  return api.get(`${apiUrlPrefix}/statuses-all`) as Promise<CodeBook[]>;
};

export const getCountyCommitteeRoleList = async () => {
  return api.get(`${apiUrlPrefix}/roles-all`) as Promise<CommitteeRole[]>;
};

export const saveCountyCommittee = async (item: CountyCommittee) => {
  return api.put(`${apiUrlPrefix}/save-committee`, item) as Promise<
    SaveResult<CountyCommittee>
  >;
};

export const searchCountyCommitteeEmployee = async (
  search: CodeBookPagedFilter
) => {
  return api.post(`${apiUrlPrefix}/search-employees`, search) as Promise<
    PagedResult<CodeBook>
  >;
};

export const getCountyCommitteeInstitutionListExport = async (
  countyId: number,
  type: ExportTypeEnum
) => {
  return api.download(
    `${apiUrlPrefix}/institution-export/${countyId}/${type}`,
    "get"
  ) as Promise<any>;
};
